import { Lock } from "lucide-react";
import { Switch } from "@/components/ui/switch";

export function PolicySwitches({ policy, onChange }) {
  const rows = [
    { key: "allow_presets", label: "Staff can choose a personal theme", hint: "High Contrast always stays available for accessibility." },
    { key: "allow_custom", label: "Staff can set their own colours", hint: "Unreadable combinations are always blocked." },
  ];
  return (
    <div className="divide-y divide-zinc-100 rounded-lg border border-le-border bg-le-surface">
      {rows.map((r) => (
        <label key={r.key} className="flex cursor-pointer items-center justify-between gap-4 px-3 py-2.5">
          <span>
            <span className="block text-sm font-medium text-le-text">{r.label}</span>
            <span className="block text-xs text-le-t-2">{r.hint}</span>
          </span>
          <Switch checked={!!policy[r.key]} onCheckedChange={(v) => onChange({ ...policy, [r.key]: v })} data-testid={`clinic-policy-${r.key}`} />
        </label>
      ))}
    </div>
  );
}

export function PresetApprovals({ presets, locked, current, onToggle, busy }) {
  return (
    <div className="divide-y divide-zinc-100 rounded-lg border border-le-border bg-le-surface" data-testid="clinic-preset-approvals">
      {presets.map((p) => {
        const isLocked = locked.includes(p.id) || p.id === current;
        return (
          <div key={p.id} className="flex items-center justify-between gap-4 px-3 py-2.5">
            <span>
              <span className="block text-sm font-medium text-le-text">{p.name}</span>
              <span className="flex items-center gap-1 text-xs text-le-t-2">
                {isLocked && <Lock className="h-3 w-3" aria-hidden />}
                {locked.includes(p.id) ? "Always available" : p.id === current ? "Current clinic default" : p.enabled ? "Staff can choose it" : "Hidden from staff"}
              </span>
            </span>
            <Switch
              checked={p.enabled}
              disabled={isLocked || busy}
              onCheckedChange={(v) => onToggle(p.id, v)}
              aria-label={`${p.name} available`}
              data-testid={`clinic-preset-toggle-${p.id}`}
            />
          </div>
        );
      })}
    </div>
  );
}
